// src/config/env.ts

interface EnvironmentConfig {
    REACT_APP_API_BASE_URL: string;
    REACT_APP_COGNITO_USER_POOL_ID: string;
    REACT_APP_COGNITO_CLIENT_ID: string;
    REACT_APP_COGNITO_DOMAIN: string;
    REACT_APP_COGNITO_REGION: string;
    REACT_APP_ENVIRONMENT: string;
    REACT_APP_COGNITO_RESOURCE_SERVER_IDENTIFIER: string;
}

// Import the mock env for tests
import { env } from './__mocks__/env';

export async function loadEnvConfig(): Promise<EnvironmentConfig> {
  // Check if we're in development mode
  if (process.env.NODE_ENV === 'test') {
    const { loadEnvConfig: mockLoadEnvConfig } = await import('./__mocks__/env');
    return mockLoadEnvConfig();
  }

  try {
    // In development, try to load local config first
    if (env.DEV) {
      try {
        // Use dynamic import for local config
        const localConfig = await import('@config/config.local.json');
        return localConfig.default;
      } catch (error) {
        console.warn('No local config found, falling back to remote config');
      }
    }

    // Try to load remote config
    const response = await fetch('/config.json');
    if (!response.ok) {
      throw new Error('Failed to load configuration');
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading configuration:', error);
    throw new Error('Failed to load any configuration. Please run `npm run setup-local-config` to generate local config.');
  }
}
  